import React from 'react';
import { Typography } from '@deeptrue-frontend/ui';
import styled from 'styled-components/macro';
import { ReportType, SubgroupType } from './types';

const StyledTabs = styled.ul`
  list-style-type: none;
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #e6e6e5;
  min-height: 2.5rem;
  margin-bottom: 1rem;

  li:first-of-type {
    margin-left: 0;
  }
  li:last-of-type {
    margin-right: 0;
  }
`;

const StyledTab = styled.li<{ isSelected: boolean }>`
  padding: 0.5rem 0;
  margin: 0 1rem;
  cursor: pointer;
  text-transform: capitalize;

  ${({ isSelected }) =>
    isSelected &&
    `
    border-bottom:2px solid #1F5DEA;

    p {
      color:#1F5DEA;
    }
  `}
`;

const Ol = styled.ol<{ listType: 'lower-latin' | 'lower-roman' }>`
  list-style-type: ${({ listType }) => listType};
  padding: 0 1rem;
`;

const Li = styled.li`
  padding: 4px 0;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;

  &:hover {
    color: black;
  }
`;

const StyledListText = styled(Typography)<{ isActive: boolean }>`
  ${({ isActive }) =>
    isActive &&
    `
    color:#1F5DEA;
    font-weight: 500;
`}
`;

const GroupTitle = styled(Typography)<{
  isActive: boolean;
  withPadding: boolean;
}>`
  ${({ withPadding }) =>
    withPadding &&
    `
  padding-top: 1.5rem;
`}
  ${({ isActive }) =>
    isActive &&
    `
    color:#1F5DEA;
    font-weight: 500;
`}
`;

const SatisfactionNotes = styled.div``;

interface TabType {
  value: number;
  name: string;
}

interface Props {
  tabs: Array<TabType>;
  selectedTab: number;
  changeTab: (value: number) => void;
  reportsLegend: Array<ReportType>;
  setSection: (section: any) => void;
  selectedSection: any;
}

const Legend = ({
  tabs,
  selectedTab,
  changeTab,
  reportsLegend,
  setSection,
  selectedSection,
}: Props) => {
  return (
    <SatisfactionNotes>
      <Typography mt="1.5rem" mb="2rem" variant="h6" weight="medium">
        Brand Asset Valuator
      </Typography>

      <StyledTabs>
        {tabs.map((tabValue: TabType) => {
          return (
            <StyledTab
              isSelected={tabValue.value === selectedTab}
              key={tabValue.value}
              onClick={() => changeTab(tabValue.value)}
            >
              <Typography variant="copy2">{tabValue.name}</Typography>
            </StyledTab>
          );
        })}
      </StyledTabs>

      <Ol listType="lower-latin">
        {reportsLegend.map((group: ReportType, index: number) => {
          const { group_name, subgroups } = group;
          const isGroupSelected =
            selectedSection &&
            selectedSection.selected_group_name === `${group_name}-${index}`;

          return (
            <Li
              key={index}
              onClick={(e) => {
                e.stopPropagation();

                setSection({
                  isWholeGroupSelected: true,
                  ...group,
                  group_name: group.group_name,
                  selected_group_name: `${group.group_name}-${index}`,
                });
              }}
            >
              <GroupTitle
                isActive={isGroupSelected}
                color="black"
                withPadding={index !== 0}
              >
                {group_name}
              </GroupTitle>
              {subgroups && (
                <Ol listType="lower-roman">
                  {subgroups.map((subgroup: SubgroupType) => {
                    const isItemSelected =
                      (isGroupSelected &&
                        selectedSection.isWholeGroupSelected) ||
                      (isGroupSelected &&
                        selectedSection.name === subgroup.name);

                    return (
                      <Li
                        key={subgroup.name}
                        onClick={(e) => {
                          e.stopPropagation();

                          setSection({
                            group_name: group.group_name,
                            selected_group_name: `${group.group_name}-${index}`,
                            isWholeGroupSelected: false,
                            ...subgroup,
                          });
                        }}
                      >
                        <StyledListText
                          isActive={isItemSelected}
                          color="#5C6370"
                        >
                          {subgroup.name}
                        </StyledListText>
                      </Li>
                    );
                  })}
                </Ol>
              )}
            </Li>
          );
        })}
      </Ol>
    </SatisfactionNotes>
  );
};

export default Legend;
